import React from "react";
import ServicePage from "./Components/ServiceComponent";
import backgroundMobil from "../../assets/img/property2.jpg"; // Assurez-vous d'avoir une image appropriée
import mobileDevImage from "../../assets/img/property.jpg";
import {
  FaMobileAlt,
  FaReact,
  FaCode,
  FaRocket,
  FaPaintBrush,
  FaLaptop,
  FaHandPointRight,
} from "react-icons/fa";
import IntlMessages from "../../intl/IntlMessages";

const CivilEngeneering = () => {
  return (
    <ServicePage
      title={<IntlMessages id="content.btp" />}
      description={
        <div>
          <p>
            <IntlMessages id="civil.vision" />
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil1" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil2" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil3" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil4" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil5" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil6" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil7" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil8" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil9" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaHandPointRight />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.civil10" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={mobileDevImage}
      altText={<IntlMessages id="softwareDevelopment.altText" />}
      heroBackgroundImage={backgroundMobil}
    />
  );
};

export default CivilEngeneering;
